/**
 * PATH: packages/ui/src/components/settings/allKanbanSettingsTabRegistry.ts
 * FILE_ID: UI-SETTINGS-ALL-KANBAN-REG-001
 * PURPOSE: Boot-time All Kanban tab body so Settings can stay graph-light.
 * ROLE IN ARCHITECTURE: Registry only. Preferences tab reads; Kanban host writes.
 * MAIN EXPORTS: registerAllKanbanSettingsTab, getAllKanbanSettingsTab
 * NON-RESPONSIBILITIES: Does not import settings-home or persist prefs.
 * NOTES FOR FUTURE AI: Do not import AllKanbanSettingsTab from this file.
 */

import type { ComponentType } from 'react'

export type AllKanbanSettingsTabProps = {
  userId?: string | number | null
  organisationId?: string | number
}

type AllKanbanSettingsTabComponent = ComponentType<AllKanbanSettingsTabProps>

let renderer: AllKanbanSettingsTabComponent | null = null

/** Remember the real All Kanban tab body after Kanban host boot. */
export function registerAllKanbanSettingsTab(
  next: AllKanbanSettingsTabComponent | null,
): void {
  renderer = next
}

/** Registered tab body, or null until Kanban host boot. */
export function getAllKanbanSettingsTab(): AllKanbanSettingsTabComponent | null {
  return renderer
}
